import { render, staticRenderFns } from "./category.vue?vue&type=template&id=3d81573d&scoped=true&"
import script from "./category.vue?vue&type=script&lang=js&"
export * from "./category.vue?vue&type=script&lang=js&"
import style0 from "./category.vue?vue&type=style&index=0&id=3d81573d&scoped=true&lang=css&"
import style1 from "./category.vue?vue&type=style&index=1&id=3d81573d&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d81573d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d81573d')) {
      api.createRecord('3d81573d', component.options)
    } else {
      api.reload('3d81573d', component.options)
    }
    module.hot.accept("./category.vue?vue&type=template&id=3d81573d&scoped=true&", function () {
      api.rerender('3d81573d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/category.vue"
export default component.exports